module.exports = __webpack_public_path__ + "static/img/rank_all_k_2.356a7cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_all_k_2.png
// module id = 53hM
// module chunks = 0